import { useQuery } from "@tanstack/react-query";
import { Navigate, useLocation } from "react-router-dom";
import { IS_FIRST_LOGIN } from "store/slices/appSlice";
import { updateAllTableFilters } from "store/slices/tableSlice";
import { CURRENT_USER, USER_LOADING } from "store/slices/userSlice";
import { useAppDispatch, useAppSelector } from "store/store";
import axiosInstance from "utils/axiosInstance";
import { currentVersion } from "utils/constants";
import { QueryKeys } from "utils/queryKey";

const PrivateRoute = ({ children }: any) => {
  const dispatch = useAppDispatch();
  const location = useLocation();

  const commonFilter = useAppSelector((state) => state?.table?.commonFilter);

  const isCalledApi =
    Boolean(localStorage.getItem(`token`)) &&
    !location.pathname?.includes("/broker-integration") &&
    location?.pathname !== "client-risk-profile" &&
    !location.pathname?.includes("/broker-integration/order") &&
    !location.pathname?.includes("/connect-client-payment-gateway") &&
    !location.pathname?.includes("/broker-integration/broker");

  useQuery({
    queryKey: [QueryKeys.GET_USER_DETAIL],
    queryFn: () => axiosInstance.get(`/user-details/`),
    enabled: isCalledApi,
    onSuccess: (data) => {
      dispatch(CURRENT_USER({ ...data?.data?.data }));
      localStorage?.setItem("token", JSON.stringify(data?.data?.data?.token));
      localStorage?.setItem("role", data?.data?.data?.userRole);
      localStorage?.setItem("product-version", currentVersion);
      dispatch(IS_FIRST_LOGIN(data?.data?.data?.isFirst));

      const d = Object.entries(commonFilter)?.map(([key, val]: [any, any]) => {
        return {
          [key]: {
            ...val,
            showNonZero: data?.data?.data?.showZeroHoldingTables,
          },
        };
      });

      const combinedObject: any = d.reduce((acc, obj) => {
        const item = Object.keys(obj)[0] as any;
        acc[item] = obj[item];
        return acc;
      }, {});

      dispatch(updateAllTableFilters(combinedObject));
      dispatch(USER_LOADING(false));
    },
    onError: (error: {
      response: { status: number; data: { message: string } };
    }) => {
      if (error?.response?.status === 401) {
        <Navigate to={"/"} replace />;
        localStorage.removeItem(`token`);
        localStorage.removeItem(`product-version`);
        window.location.reload();
        dispatch(USER_LOADING(false));
      }
    },
  });

  return localStorage.getItem("token") ? children : <Navigate to="/login" />;
};

export default PrivateRoute;
